import React, { useContext, useEffect, useState } from "react";
import AuthContext from "../../store/auth-context";
import { userService } from "../../services/UserService";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

function ViewLogs(props: any) {
  const authCtx = useContext(AuthContext);
  const [activityLogsList, setActivityLogsList] = useState<any>([]);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalText, setModalText] = useState<string>("");
  const [modalType, setModalType] = useState<string>("error");

  useEffect(() => {
    fetchActivityLogs();
  }, []);

  const fetchActivityLogs = async () => {
    authCtx.toggleLoader(true);
    const res = await userService.getOfferActivityLogs(props.offerInterestId);
    if (res && res.length > 0) {
      setActivityLogsList(res.reverse());
    } else {
      setModalText("Something went wrong!");
      setModalType("error");
      setShowModal(true);
    }
    authCtx.toggleLoader(false);
  };

  const handleClose = () => setShowModal(false);

  return (
    <>
      {activityLogsList &&
        activityLogsList.length > 0 &&
        activityLogsList.map((item: any) => (
          <div className="card border-0 rounded-10 shadow-sm mb-3 light-bg p-3">
            <p className="my-0">
              <strong className="text-black">
                {new Date(item.createdAt).toDateString() +
                  " - " +
                  new Date(item.createdAt).toLocaleTimeString("en-US", {
                    hour12: true,
                    hour: "numeric",
                    minute: "numeric",
                  })}{" "}
                - {item.createdByName}
              </strong>{" "}
              has updated the status to{" "}
              <strong className="text-black">{item.status}</strong>{" "}
              {item.comment &&
                item.comment !== "" &&
                `with comment - ${item.comment}`}
            </p>
          </div>
        ))}

      {modalType === "error" && (
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          open={showModal}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          <Alert onClose={handleClose} severity="error">
            {modalText}
          </Alert>
        </Snackbar>
      )}
    </>
  );
}

export default ViewLogs;
